import React from 'react';

/**
 * Atmosphere — nébuleuses violettes/azur floutées en arrière-plan d'une section.
 * À placer dans un parent `relative overflow-hidden`. Purement décoratif.
 */
const Atmosphere = ({ variant = 'default' }) => {
  const presets = {
    default: [
      { c: 'rgba(138,43,226,0.45)', s: 520, top: '-10%', left: '-8%', anim: 'aurora 20s ease-in-out infinite' },
      { c: 'rgba(97,145,254,0.30)', s: 460, top: '30%', left: '78%', anim: 'aurora 26s ease-in-out infinite reverse' },
      { c: 'rgba(232,121,249,0.18)', s: 420, top: '75%', left: '20%', anim: 'aurora 30s ease-in-out infinite' },
    ],
    top: [
      { c: 'rgba(138,43,226,0.5)', s: 600, top: '-25%', left: '50%', anim: 'aurora 22s ease-in-out infinite' },
      { c: 'rgba(97,145,254,0.32)', s: 480, top: '-10%', left: '10%', anim: 'aurora 28s ease-in-out infinite reverse' },
    ],
    calm: [
      { c: 'rgba(124,92,255,0.25)', s: 520, top: '10%', left: '70%', anim: 'aurora 32s ease-in-out infinite' },
      { c: 'rgba(138,43,226,0.22)', s: 460, top: '60%', left: '-6%', anim: 'aurora 36s ease-in-out infinite reverse' },
    ],
  };

  return (
    <div aria-hidden="true" className="absolute inset-0 -z-10 overflow-hidden">
      {(presets[variant] || presets.default).map((b, i) => (
        <span
          key={i}
          className="blob"
          style={{
            background: b.c,
            width: b.s,
            height: b.s,
            top: b.top,
            left: b.left,
            transform: 'translate(-50%, -50%)',
            animation: b.anim,
          }}
        />
      ))}
      {/* léger maillage de points */}
      <div
        className="absolute inset-0 opacity-[0.25]"
        style={{
          backgroundImage:
            'radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px)',
          backgroundSize: '34px 34px',
          maskImage: 'radial-gradient(70% 60% at 50% 40%, #000, transparent 75%)',
          WebkitMaskImage: 'radial-gradient(70% 60% at 50% 40%, #000, transparent 75%)',
        }}
      />
    </div>
  );
};

export default Atmosphere;
